import { FormTypes } from '../globalDestServiceConstants';
import {
  createGlobalDestinationColumns,
  createGlobalDestinationPostRequest,
  createGlobalDestinationPutRequest,
  createGlobalDestinationRows
} from '../formData/destServiceFormData';
import { showToast } from 'modules/layout/layout.actions';
import { useCreateDataHandler } from '../apiHandlers/useCreateDataHandler';
import { useDeleteDataHandler } from '../apiHandlers/useDeleteDataHandler';
import { useFetchGlobalDestinationServiceDataHandler } from '../apiHandlers/useFetchDataHandler';
import { useUpdateDataHandler } from '../apiHandlers/useUpdateDataHandler';
import CrudTable from 'modules/clients/details/crudTable.component';
import React, { useRef, useState } from 'react';
import SpinnerComponent from 'modules/common/spinner.component';

const DestinationServicesCrudTable = ({ authId, globalId, isReadOnly, enumerations, destinationData, vendors, vendorContacts, allVendors, familyMembers }) => {
  const createDataHandler = useCreateDataHandler(showToast);
  const updateDataHandler = useUpdateDataHandler(showToast);
  const deleteDataHandler = useDeleteDataHandler(showToast);
  const dataHandler = useFetchGlobalDestinationServiceDataHandler(showToast);
  const columns = createGlobalDestinationColumns(vendors, vendorContacts, enumerations, allVendors, familyMembers);

  const [isLocalLoading, setIsLocalLoading] = useState(false);
  const scrollPositionRef = useRef(0);
  const containerRef = useRef(null);

  const handleCrudOperation = async (operation, ...args) => {
    scrollPositionRef.current = window.scrollY;
    setIsLocalLoading(true);
    const response = await operation(...args);
    if (response) {
      await dataHandler.fetchData(authId);
    }
    setTimeout(() => {
      window.scrollTo(0, scrollPositionRef.current);
      setIsLocalLoading(false);
    }, 0);
    return response;
  };

  const updateRow = async (originalRow, newRow) => {
    if (!hasRequiredAdvancedSearchValues(columns, newRow)) {
      showToast('Please complete all required search fields before saving.', { severity: 'error' });
      return false;
    }

    return await handleCrudOperation(
      updateDataHandler.updateData,
      FormTypes.DestinationService,
      authId,
      globalId,
      destinationData[originalRow.index].globalDestinationServiceId,
      createGlobalDestinationPutRequest(destinationData[originalRow.index], newRow, globalId)
    );
  };

  const createRow = async newRow => {
    if (!hasRequiredAdvancedSearchValues(columns, newRow)) {
      showToast('Please complete all required search fields before saving.', { severity: 'error' });
      return false;
    }

    return await handleCrudOperation(
      createDataHandler.createData,
      FormTypes.DestinationService,
      authId,
      globalId,
      createGlobalDestinationPostRequest(newRow, globalId)
    );
  };

  const deleteRow = async rowToDelete => {
    return await handleCrudOperation(
      deleteDataHandler.deleteData,
      FormTypes.DestinationService,
      authId,
      globalId,
      rowToDelete.original.globalDestinationServiceId
    );
  };

  return (
    <div style={{ minHeight: '200px', position: 'relative' }} ref={containerRef}>
      {isLocalLoading ? (
        <div style={{ position: 'absolute', display: 'flex' }}>
          <SpinnerComponent />
        </div>
      ) : (
        <CrudTable
          editingMode={'modal'}
          columns={columns}
          rows={createGlobalDestinationRows(destinationData, vendors, vendorContacts)}
          updateRow={updateRow}
          createRow={createRow}
          deleteRow={deleteRow}
          customAddText={'Add Destination Service'}
          hideEdit={isReadOnly}
          toolbarCustomButton={true}
          customButtonText={'Order Service'}
          customButtonMethod={() => alert('Order Service Letter Sent Successfully!')}
        />
      )}
    </div>
  );
};

const hasRequiredAdvancedSearchValues = (columns, values) => {
  return columns
    .filter(column => column.type === 'advanced-search' && column.required)
    .every(column => {
      const value = values[column.accessorKey];
      return value !== null && value !== undefined && value !== '';
    });
};

export default DestinationServicesCrudTable;